<template>
  <v-app-bar
    style="z-index: 10; pointer-events: none"
    :flat="!hasToolbar"
    :absolute="!hasToolbar"
    :app="hasToolbar" dark dense
    :color="getToolbarColour()">
    <v-row no-gutters>
      <v-col class="mr-1">
        <span class="title float-left pt-1 text-truncate" style="width: calc(100% - 310px)" v-if="showTitle">{{CONFIG.title}}</span>
        <v-spacer></v-spacer>
        <postcode-search class="float-right" v-if="hasPostcode"></postcode-search>
        <llpg-search class="float-right" v-if="hasLlpg"></llpg-search>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
  import { mapGetters } from 'vuex';
  import PostcodeSearch from './PostcodeSearch';
  import LlpgSearch from './LlpgSearch';

  export default {
    name: 'TheToolbar',
    components: {
      LlpgSearch,
      PostcodeSearch
    },
    computed: {
      ...mapGetters(['TOOLS', 'CONFIG']),
      toolbarConfig() {
        if (this.CONFIG?.config.toolbar){
        return this.CONFIG.config.toolbar;
        } else {
          return {
            logo: null
          }
        }
      },
      showTitle(){
        return !!this.CONFIG.config.showTitle
      },
      hasToolbar() {
        if (this.showTitle) return true;
        return false;
      },
      hasPostcode() {
        return this.TOOLS.indexOf('postcodeSearch') > -1;
      },
      hasLlpg() {
        return this.TOOLS.indexOf('llpgSearch') > -1;
      }
    },

    methods: {
      logoUrl() {
        return `${process.env.VUE_APP_AUTH_URL}/logos/${this.toolbarConfig.logo}`;
      },
      getToolbarColour() {
        if (this.hasToolbar) {
          return 'primary';
        } else {
          return 'rgba(0,0,0,0)';
        }
      }
    },

    data() {
      return {};
    }
  };
</script>

<style scoped>

</style>
